import { render, staticRenderFns } from "./EntitlementPage.vue?vue&type=template&id=7ef82dad&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef82dad')) {
      api.createRecord('7ef82dad', component.options)
    } else {
      api.reload('7ef82dad', component.options)
    }
    module.hot.accept("./EntitlementPage.vue?vue&type=template&id=7ef82dad&", function () {
      api.rerender('7ef82dad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entitlements/EntitlementPage.vue"
export default component.exports